import {BaseEntity} from "./BaseEntity";

export class User implements BaseEntity {
    constructor(public id?: number,
        public username?: string,
        public password?: string,
        public firstName?: string,
        public lastName?: string,
        public email?: string,
        public phone?: string,
        public cardID?: string,
        public rfidTag?: string,
        public hideAdminPopups?: boolean,
        public companyID?: number,
        public companyName?:string,
        public userType:string = "View Only"){
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.username = json.username;
        this.password = json.password;
        this.firstName = json.firstName;
        this.lastName =json.lastName;
        this.email = json.email;
        this.phone = json.phone;
        this.cardID =json.cardID;
        this.rfidTag = json.rfidTag;
        this.hideAdminPopups = json.hideAdminPopups;
        this.companyID = json.companyID;
        this.companyName = json.companyName;
        this.userType = json.userType;
    }
}
